/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Destek_KanallarInputs */

const tr_faq_q_destek_kanallar = /** @type {(inputs: Faq_Q_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorun yaşarsam nereden yardım alabilirim?`)
};

const en_faq_q_destek_kanallar = /** @type {(inputs: Faq_Q_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where can I get help?`)
};

const de_faq_q_destek_kanallar = /** @type {(inputs: Faq_Q_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo bekomme ich Hilfe?`)
};

const ru_faq_q_destek_kanallar = /** @type {(inputs: Faq_Q_Destek_KanallarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Где получить помощь?`)
};

/**
* | output |
* | --- |
* | "Where can I get help?" |
*
* @param {Faq_Q_Destek_KanallarInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_destek_kanallar = /** @type {((inputs?: Faq_Q_Destek_KanallarInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Destek_KanallarInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_destek_kanallar(inputs)
	if (locale === "de") return de_faq_q_destek_kanallar(inputs)
	if (locale === "ru") return ru_faq_q_destek_kanallar(inputs)
	return tr_faq_q_destek_kanallar(inputs)
});